<template>
  <Content />
</template>

<script>
import { mapState } from "pinia";
import authStore from "../store/auth";
import FooterLanding from "../components/landing/footer.vue";
import Content from "../components/landing/content.vue";
import HeaderLanding from "../components/landing/header.vue";

export default {
  components: {
    FooterLanding,
    Content,
    HeaderLanding,
  },
  computed: {
    ...mapState(authStore, ["isLoggedIn"]),
  },
  mounted() {
    if (!this.isLoggedIn) {
      this.$router.push("/app/login");
    }
  },
  methods: {
    handleClick: () => {},
  },
};
</script>

<style scoped>
.n-result {
  margin: 10vh 0;
}
</style>
